import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import { apiMiddleware } from "redux-api-middleware";
import thunk from "redux-thunk";

import { reducer as authReducer, AuthActionTypes } from "services/auth";
import { reducer as usersReducer } from 'services/api/users';
import { reducer as settingsReducer } from 'services/api/settings';
import { reducer as tenantsReducer } from 'services/api/tenants';
import { reducer as languagesReducer } from 'services/api/languages';
import { reducer as translationsReducer } from 'services/api/translations';
import { AppStore, State } from "./types";

const appReducer = combineReducers<State>({
  auth: authReducer,
  user: usersReducer,
  settings: settingsReducer,
  tenant: tenantsReducer,
  languages: languagesReducer,
  translations: translationsReducer,
});

const rootReducer = (state: State, action: any) => {
  if (action.type === AuthActionTypes.SIGN_OUT) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const middlewares = [thunk, apiMiddleware];

function getCompose() {
  const IS_BROWSER = typeof window !== "undefined" && "HTMLElement" in window;
  if (IS_BROWSER && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    return (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  }
  return compose;
}

const composeEnhancers = getCompose();

export const store: AppStore = createStore(
  rootReducer as any,
  composeEnhancers(applyMiddleware(...middlewares))
);
